import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { FormEERData } from "@/trust-atcs-app/models/form-eer-data";
import { EeReport, EeReportDeclaration } from "@/shared/modules/typescript-trustapi-client/models";
import { AuthorizedUser } from "@/trust-atcs-app/models/authorized-user";

@Options({
  components: {
    LoadingSpinner,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormEerDeclaration extends Vue {

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop({ default: {} })
  private formEERData!: FormEERData;

  @Emit('update:isSectionLoading')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private errorLoadingContent = false;

  private additionalInfo = '';
  private declarationContent: EeReportDeclaration = {}

  mounted(): void {
    this.$emit('validForm', false);
    this.eventCtrl.on('reload-form-eer-declaration-content', this.loadDeclarationContent);
    this.loadDeclarationContent();
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-eer-declaration-content', this.loadDeclarationContent);
  }

  private async loadDeclarationContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.EeReportApi?.apiV2EeReportGetDeclarationPost({
        complianceFormId: this.complianceFormEER.id,
        updatingKey: this.updatingKey,
      });
      this.declarationContent = resp.data.data as EeReportDeclaration;
      this.formEERData.declarationDetails = this.declarationContent;
      this.checkCanGoNext();
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting declaration details');
      this.ai.trackException('Error getting declaration details: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private checkCanGoNext(): void {
    // const canGoNext = this.declarationContent.additionalInformation?.length > 0;
    this.$emit('validForm', true);
  }

  get complianceFormEER(): EeReport {
    return store.getters.getSelectedComplianceFormEER;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get completer(): string {
    try {
      return this.userAccount?.user?.firstName + ' ' + this.userAccount?.user?.lastName + ' of ' + this.declarationContent?.externalExaminer?.firmName;
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  get membershipType(): string {
    // TODO: Implement this
    return this.declarationContent?.externalExaminer?.eeMembershipType?.name;
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

}
